import { globalUserState } from "state";
import { selfuserQuery, updateuserMutation } from "../../graphql/queries";
import { SelfUserQuery, SelfUserQueryVariables, UpdateUserMutation, UpdateUserMutationVariables } from "../../graphql/types";
import { fetchGraphql } from "./graphqlClient";

export type UserProfile = NonNullable<SelfUserQuery["self"]>;

export async function fetchSelfUser(): Promise<UserProfile | null> {
    const result = await fetchGraphql<SelfUserQuery, SelfUserQueryVariables>("SelfUser", selfuserQuery, {}, true);
    return result.data?.self ?? null;
}

export async function updateUser(input: Partial<UpdateUserMutationVariables["input"]>): Promise<boolean> {
    if (!globalUserState.value.user) return false;

    try {
        const updateReslt = await fetchGraphql<UpdateUserMutation, UpdateUserMutationVariables>("UpdateUser", updateuserMutation, {
            input: {
                userId: globalUserState.value.user.id,
                ...input
            }
        }, true);
        return !!updateReslt?.data?.user.updateUser?.ok;
    }
    catch {
    }
    return false;
}
